import { Children, type PropsWithChildren, type ReactNode } from 'react';

export type LimitChildrenProps = PropsWithChildren<{
  overflowElement: (remaining: number, hiddenChildren: ReactNode[]) => ReactNode;
  limit?: number;
}>;

// Limits the number of children to `limit`. If it exceeds this, it will show the overflow element
// at the end (e.g. `+11`)
export function LimitChildren({ children, overflowElement, limit }: LimitChildrenProps) {
  if (limit === undefined) {
    return children;
  }

  if (Children.count(children) <= limit) {
    return children;
  }

  const allChildren = Children.toArray(children);
  const hiddenChildren = allChildren.slice(limit - 1);
  const remaining = hiddenChildren.length;
  return [...allChildren.slice(0, limit - 1), overflowElement(remaining, hiddenChildren)];
}
